export default "__VITE_ASSET__B1p$XHAr__"